export default {"src":"/_next/static/media/logo_white.bd323623.svg","height":37,"width":198,"blurWidth":0,"blurHeight":0};